<template>
<div class="otp-field-group">
	<h4>{{ $t(title) }}</h4>
	<div class="text-secondary mb-4">
		Masukkan 6 digit kode yang dikirim ke email {{ censoredEmail }}
	</div>
	<div class="form-group">
		<input
			type="number"
			class="form-control"
			size="6"
			:value="value"
			@input="onOtpChange"
		>
	</div>
	<!-- Re-Send -->
	<div>
		<button
			class="btn btn-link px-0 btn-regenerate-otp"
			:class="{
				'text-grey-dark': otpTimerValue !== 0,
				'is-loading': isGeneratingOtp
			}"
			:disabled="otpTimerValue !== 0"
			@click="generateOtp">
			Kirim ulang kode ({{ otpTimer }})
		</button>
	</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	generateTimerLabel,
	getAxiosErrorMessage,
	sensorEmailAddress,
} from '@/lib/helper';
import otpApi from '@/api/otp';

export default {
	name: 'OTPField',
	props: {
		value: {
			type: String,
			default: '',
		},
		email: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: 'Verfikasi penarikan dana kamu',
		},
		type: {
			type: String,
			default: 'withdrawal',
		},
		generate: {
			type: Boolean,
			default: false,
		},
		payloads: {
			type: Object,
			default: () => ({}),
		},
		autoStartTimer: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isGeneratingOtp: false,
			otpTimerValue: 0,
			otpTimerInterval: null,
			maxOtpTime: 300,
		};
	},
	methods: {
		onOtpChange(e) {
			let value = e.target.value;
			if (!Number.isNaN(value)) {
				value = value.toString();
			}
			this.$emit('input', value);
		},
		generateOtp() {
			this.isGeneratingOtp = true;
			const payloadJson = JSON.stringify(this.payloads);
			const params = {
				type: this.type,
				payload: payloadJson,
			};
			const callback = () => {
				this.isGeneratingOtp = false;
				// Start OTP Timer Interval
				this.startOtpTimer();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'OTP Code',
					text: message,
				});
				this.isGeneratingOtp = false;
				this.startOtpTimer();
			};
			otpApi.generate(params, callback, errorCallback);
		},
		startOtpTimer() {
			this.otpTimerValue = parseInt(this.maxOtpTime);
			const otpInterval = setInterval(() => {
				this.otpTimerValue--;
				if (this.otpTimerValue === 0) {
					clearInterval(this.otpTimerInterval);
				}
			}, 1000);

			this.otpTimerInterval = otpInterval;
		},
		validateOtp() {
			this.isValidatingOtp = true;
			const code = this.otpCode.trim();
			const params = {
				code,
			};
			const callback = (response) => {
				console.log(response);
				this.isValidatingOtp = false;
				this.withdraw();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'OTP Validation',
					text: message,
				});
				this.isValidatingOtp = false;
			};
			otpApi.validate(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
		}),
		userEmail() {
			let userEmail = this.user.email;
			if (this.email !== '') {
				userEmail = this.email;
			}
			return userEmail;
		},
		censoredEmail() {
			const email = this.userEmail;
			const censoredEmail = this.isOwner ? sensorEmailAddress(email) : 'Owner account ini';
			return censoredEmail;
		},
		otpTimer() {
			const timerLabel = generateTimerLabel(this.otpTimerValue);
			return timerLabel;
		},
		otpPayload() {
			const payload = {};
			return payload;
		},
		// isOtpValid() {
		// 	return this.value && this.value.length === 6;
		// },
	},
	created() {
		if (this.generate) {
			this.generateOtp();
		} else if (this.autoStartTimer) {
			this.startOtpTimer();
		}
	},
};
</script>
